// extracted by mini-css-extract-plugin
export default {"contentWrapper":"Modal_contentWrapper__rIiKq","closeButton":"Modal_closeButton__E6Kx0"};